import { authComponents_svSE } from "@ssf/auth-components";
import { components_svSE, markdownToHtmlSync } from "@ssf/components";
import { memdbComponents_svSE } from "@ssf/memdb-components";
import i18next, { use } from "i18next";
import { merge } from "lodash";
import { initReactI18next } from "react-i18next";

import s4Web_svSE from "../locales/locale.sv-SE.json";

const svSE = {
  ...merge(
    components_svSE,
    authComponents_svSE,
    memdbComponents_svSE,
    s4Web_svSE,
  ),
  Questions: [...memdbComponents_svSE.Questions, ...s4Web_svSE.Questions],
};

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "common";
    resources: typeof s4Web_svSE;
  }
}

use(initReactI18next)
  .use({
    type: "postProcessor",
    name: "markdown",
    process: (value: string) => markdownToHtmlSync(value),
  })
  .init({
    lng: "svSE",
    fallbackLng: "svSE",
    defaultNS: "common",
    resources: { svSE },
    react: {
      useSuspense: true,
      transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p",
        "em",
        "a",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "ul",
        "ol",
        "li",
      ],
    },
  });

i18next.services.formatter?.add("lowercase", (value) => value.toLowerCase());

export { i18next };
